import { render, staticRenderFns } from "./editDiy.vue?vue&type=template&id=5c407b61&scoped=true"
import script from "./editDiy.vue?vue&type=script&lang=js"
export * from "./editDiy.vue?vue&type=script&lang=js"
import style0 from "./editDiy.vue?vue&type=style&index=0&id=5c407b61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c407b61",
  null
  
)

export default component.exports